import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild
} from '@angular/core';
import chroma from 'chroma-js';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { DynamicFormComponentV3 } from '../dynamic-form/dynamic-form.component';

@Component({
  selector: 'bepatient-dynamic-form-progress-bar-v3',
  templateUrl: './dynamic-form-progress-bar.component.html',
  styleUrls: ['./dynamic-form-progress-bar.component.scss'],
  standalone: false
})
export class DynamicFormProgressBarComponentV3 implements OnDestroy {
  atLeast2Pages = false;

  private color: string;
  private progress: number;
  private background: ElementRef;
  private progressBar: ElementRef;
  private subscriptions: Array<Subscription> = [];

  @Input() set form(v: DynamicFormComponentV3) {
    this.unsubscribe();
    this.subscriptions = [
      v.colorChange.pipe(startWith(v.color)).subscribe(color => {
        this.color = color;
        this.updateColors();
      }),
      v.progressChange
        .pipe(startWith(v.progress))
        .subscribe(([currentPage, pageCount]) => {
          this.progress = Math.round(100 * ((currentPage + 1) / pageCount));
          this.atLeast2Pages = pageCount > 1;
          this.updateProgressBar();
        })
    ];
  }

  @ViewChild('bg', { read: ElementRef }) set bg(v: ElementRef) {
    this.background = v;
    this.updateColors();
  }

  @ViewChild('bar', { read: ElementRef }) set bar(v: ElementRef) {
    this.progressBar = v;
    this.updateColors();
    this.updateProgressBar();
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  private unsubscribe(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private updateColors(): void {
    if (this.background) {
      this.background.nativeElement.style.setProperty(
        'background',
        chroma(this.color).alpha(0.1)
      );
    }
    if (this.progressBar) {
      this.progressBar.nativeElement.style.setProperty(
        'background',
        this.color
      );
    }
  }

  private updateProgressBar(): void {
    if (this.progressBar) {
      this.progressBar.nativeElement.style.setProperty(
        'width',
        `${this.progress}%`
      );
    }
  }
}
